var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { DATA_HOOKS } from './constants';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { Modal } from '../internal/Modal';
import { IconButton } from '../IconButton';
import Close from 'wix-ui-icons-common/on-stage/Close';
import { st, classes } from './Dialog.st.css';
/** Dialog */
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, isOpen = _a.isOpen, manualFocus = _a.manualFocus, closeButtonRef = _a.closeButtonRef, onClose = _a.onClose, children = _a.children, contentClassName = _a.contentClassName, childrenWrapperClassName = _a.childrenWrapperClassName, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"], closeButtonAriaLabel = _a.closeButtonAriaLabel, closeButtonAriaLabelledby = _a.closeButtonAriaLabelledby, wiredToSiteColors = _a.wiredToSiteColors, notFullscreenOnMobile = _a.notFullscreenOnMobile, appendToBody = _a.appendToBody, forceBWTheme = _a.forceBWTheme;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile, rtl = _a.rtl;
            return (React.createElement("div", { className: st(classes.root, {
                    mobile: mobile,
                    rtl: rtl,
                    wired: wiredToSiteColors,
                    notFullscreenMobile: mobile && notFullscreenOnMobile,
                }, classes["skin-" + (wiredToSiteColors ? 'wired' : 'fixed')], className), "data-hook": _this.props['data-hook'], "data-mobile": mobile },
                React.createElement(Modal, { isOpen: isOpen, focusTrap: !manualFocus, onRequestClose: onClose, forceBWTheme: forceBWTheme && !wiredToSiteColors, appendToBody: appendToBody },
                    React.createElement("div", { className: st(classes.outerContentWrapper, { appendToBody: appendToBody }) },
                        React.createElement("div", { className: classes.contentWrapper + " " + (contentClassName || ''), role: "dialog", "aria-modal": "true", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy },
                            React.createElement("div", { className: classes.closeButtonWrapper },
                                React.createElement(IconButton, { className: classes.closeIconButton, "data-hook": DATA_HOOKS.CLOSE_BTN, "aria-label": closeButtonAriaLabel, "aria-labelledby": closeButtonAriaLabelledby, innerRef: closeButtonRef, onClick: onClose, icon: React.createElement(Close, null) })),
                            React.createElement("div", { className: classes.dialogContent + " " + (childrenWrapperClassName || '') }, children))))));
        }));
    };
    Dialog.displayName = 'Dialog';
    Dialog.defaultProps = {
        isOpen: false,
        manualFocus: false,
        notFullscreenOnMobile: false,
    };
    return Dialog;
}(React.Component));
export { Dialog };
//# sourceMappingURL=Dialog.js.map